import { gql } from "@apollo/client";

export const GetPlanner = gql`
  query eventVendor($eventId: Int!, $page: Int, $pageSize: Int) {
    eventVendor(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      event_id
      instagram_handle
      role
      name
      email
      phone_number
      created_at
      updated_at
    }
  }
`;

export const GetMessage = gql`
  query getMessageByUser($eventId: Int!, $page: Int, $pageSize: Int) {
    getMessageByUser(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      content
      status
      event_id
      updated_at
      created_at
      user {
        first_name
        last_name
        phone_number
      }
    }
  }
`;

export const GetMessagesByEvent = gql`
  query getMessagesByEvent($eventId: Int!, $page: Int, $pageSize: Int) {
    getMessagesByEvent(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      event_id
      user {
        first_name
        last_name
        phone_number
      }
      content
      status
      created_at
      updated_at
    }
  }
`;

export const GuestCategory = gql`
  query guestCategory($eventId: Int!) {
    guestCategory(event_id: $eventId) {
      id
      event_id
      name
      created_at
      updated_at
    }
  }
`;

export const NumberOfGuestsByCategory = gql`
  query noGuestPerCategory($eventId: Int!) {
    noGuestPerCategory(event_id: $eventId) {
      category_id
      category_name
      message
      num_guest
    }
  }
`;

export const InvitationList = gql`
  query invitationList($eventId: Int!, $page: Int, $pageSize: Int) {
    invitationList(event_id: $eventId, page: $page, pageSize: $pageSize) {
      id
      first_name
      last_name
      phone
      email
      category {
        id
        name
        event_id
      }
    }
  }
`;

export const GetBackStory = gql`
  query getBackStory($eventId: Int!) {
    getBackStory(event_id: $eventId) {
      id
      role
      story
      title
      image
      event_id
    }
  }
`;

export const GetWishListItems = gql`
  query getWishListItems(
    $eventId: Int!
    $listId: Int
    $page: Int
    $pageSize: Int
  ) {
    getWishListItems(
      event_id: $eventId
      listId: $listId
      page: $page
      pageSize: $pageSize
    ) {
      id
      uuid
      wish_list_id
      name
      image
      amount
      currency
      paid
      created_at
      updated_at
    }
  }
`;
export const InvitationListByRSVP = gql`
  query invitationListByRSVPStatus(
    $eventId: Int!
    $rsvpStatus: RSVPStatus!
    $page: Int
    $pageSize: Int
  ) {
    invitationListByRSVPStatus(
      event_id: $eventId
      rsvpStatus: $rsvpStatus
      page: $page
      pageSize: $pageSize
    ) {
      id
      event_id
      first_name
      last_name
      phone
      sent
      email
      rsvp_status
      category {
        id
        event_id
        name
        created_at
        updated_at
      }
    }
  }
`;

export const EventParts = gql`
  query eventParts($eventId: Int!) {
    eventParts(event_id: $eventId) {
      id
      uuid
      event_id
      name
      part
      time
      welcome_msg
      address
      city
      state
      country
      map_coordinate
      created_at
      updated_at
      geo_position {
        geo_position_id
        latitude
        longitude
      }
    }
  }
`;

export const GetMediaTags = gql`
  query Query {
    getMediaTags
  }
`;

export const GetMedia = gql`
  query GetMedia($eventId: String!, $filter: MediaFilter!) {
    getMedia(event_id: $eventId, filter: $filter) {
      id
      name
      url
      tags
      type
      meta {
        s3_url
        height
        width
      }
      private
      user_id
      event_id
      album_id
      album {
        id
        name
        event_id
        description
        created_by
        creator {
          user_id
          first_name
          last_name
          image
        }
        created_at
        updated_at
      }
      likes
      user_type
      created_at
      updated_at
    }
  }
`;

export const GetAlbums = gql`
  query GetAlbums($eventId: String!, $page: Int, $pageSize: Int) {
    getAlbums(event_id: $eventId) {
      data {
        id
        name
        event_id
        description
        created_by
        Media(page: $page, page_size: $pageSize) {
          data {
            album {
              created_at
              created_by
              name
            }
            created_at
            id
            event_id
            album_id
            name
            tags
            type
            url
          }
        }
        created_at
        updated_at
      }
    }
  }
`;

// export const GetAlbumDetails = gql`;
//   query getAlbumDetails(
//     $eventId: String!
//     $albumId: String
//     $page: Int
//     $pageSize: Int
//   ) {
//     getAlbumDetails(
//       event_id: $eventId
//       album_id: $albumId
//       page: $page
//       pageSize: $pageSize
//     ) {
//       id
//       name
//       url
//       tags
//       type
//       meta {
//         s3_url
//         height
//         width
//       }
//       created_at
//       updated_at
//     }
//   }
// `;

export const GetEventType = gql`
  query getEventType {
    getEventType {
      id
      name
      description
    }
  }
`;

export const GetEventsForDashboard = gql`
  query getEventsForDashboard($isInvited: Boolean, $page: Int, $pageSize: Int) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      uuid
      name
      wallet_created
      hash_tag
      token
      slug
      toast
      date
      hero_image
      hero_image_thumbnail
      luxe
      event_owners {
        role
        user_id
      }
      is_admin
      event_parts {
        id
        uuid
        event_id
        name
        part
        time
        address
        city
        state
        country
        map_coordinate
        created_at
        updated_at
      }
    }
  }
`;

export const EventBySlug = gql`
  query eventBySlug($slug: String!) {
    eventBySlug(slug: $slug) {
      template_id
    }
  }
`;

export const GetInvitedEventsForDashboard = gql`
  query getInvitedEventsForDashboard(
    $isInvited: Boolean
    $page: Int
    $pageSize: Int
  ) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      uuid
      name
      hash_tag
      token
      slug
      toast
      date
      hero_image
      hero_image_thumbnail
      event_parts {
        id
        uuid
        event_id
        name
        part
        time
        welcome_msg
        address
        created_at
        updated_at
      }
    }
  }
`;

export const GetEventByIdDashboardLayout = gql`
  query getEventByIdDashboardLayout(
    $isInvited: Boolean
    $page: Int
    $pageSize: Int
  ) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      name
      event_owners {
        id
        user {
          first_name
          last_name
          uuid
          id
        }
        admin
        role
      }
    }
  }
`;

export const GetEvents = gql`
  query events($isInvited: Boolean, $page: Int, $pageSize: Int) {
    events(isInvited: $isInvited, page: $page, pageSize: $pageSize) {
      id
      uuid
      name
      wallet_created
      hash_tag
      token
      slug
      toast
      welcome_msg
      created_at
      updated_at
      date
      hero_image
      event_wallet {
        id
        balance
        currency
        pin_is_set
        frozen
        created_at
        updated_at
      }
      event_owners {
        id
        user_id
        event_id
        admin
        role
        user {
          first_name
          last_name
          image
        }
        created_at
        updated_at
      }
      event_type {
        id
        name
        description
      }
      event_parts {
        id
        uuid
        event_id
        name
        part
        time
        welcome_msg
        address
        city
        state
        country
        map_coordinate
        created_at
        updated_at
      }
      event_preference {
        id
        event_id
        food
        ads
        asoebi_selection
        gifts
        store
        vendor_store
        reservation
        dress_code
        map
        smart_send
        private
        live_hall
        created_at
        updated_at
      }
      is_admin
    }
  }
`;

export const InvitationCardTemplate = gql`
  query invitationCard($eventId: Int!) {
    invitationCard(event_id: $eventId) {
      id
      event_id
      template
      updated_at
      created_at
    }
  }
`;

export const GetEvent = gql`
  query event($eventId: Int!) {
    event(event_id: $eventId) {
      id
      token
      slug
      pass_image
      luxe
      event_preference {
        access_control
      }
      supported_currencies
      enabled_currencies
      created_at
    }
  }
`;

export const GetEventPreference = gql`
  query getEventPreference($eventId: UUID!) {
    event(event_id: $eventId) {
      event_preference {
        ads
        asoebi_selection
        created_at
        dress_code
        event_id
        id
        food
        gifts
        map
        private
        reservation
        smart_send
        store
        updated_at
        vendor_store
        access_control
      }
    }
  }
`;

export const GetEventPreferenceById = gql`
  query Event_preferences($eventId: UUID!) {
    event_preferences(event_id: $eventId) {
      access_control
      vendor_store
      dress_code
      asoebi_selection
      id
      event_id
    }
  }
`;

export const GetProfileDetails = gql`
  query user {
    user {
      id
      uuid
      gender
      first_name
      last_name
      email
      phone_number
      image
      kyc_record {
        user_id
        bank_details {
          account_name
          account_number
          bank_name
        }
        country_iso
        id
        status
      }
    }
  }
`;

export const GetLuxeDetails = gql`
  query DescribeLuxe($event_id: UUID!) {
    describeLuxe(event_id: $event_id) {
      currency
      discount_percentage
      discounted_amount
      notes
      undiscounted_amount
    }
  }
`;

export const GetUsername = gql`
  query getUsername {
    user {
      id
      uuid
      first_name
      last_name
      email
      image
      phone_number
    }
  }
`;

export const GetEventInfo = gql`
  query GetEventInfo($eventEventId2: Int!) {
    event(event_id: $eventEventId2) {
      id
      name
      hash_tag

      slug
      welcome_msg
      created_at
      updated_at
    }
  }
`;

export const GetBanksWithRave = gql`
  query getBanksWithRave($country: String!) {
    getBanksWithRave(country: $country) {
      id
      code
      name
    }
  }
`;

export const ResolveAccountWithRave = gql`
  query ResolveAccountWithRave($accountNumber: String!, $accountBank: String!) {
    resolveAccountWithRave(
      account_number: $accountNumber
      account_bank: $accountBank
    ) {
      accountName
      accountNumber
    }
  }
`;

export const FilterInvitationList = gql`
  query filterInvitationListBy(
    $eventId: Int!
    $filter: invitationListFilter!
    $page: Int!
    $pageSize: Int!
  ) {
    filterInvitationListBy(
      event_id: $eventId
      filter: $filter
      page: $page
      pageSize: $pageSize
    ) {
      id
      event_id
      event_uuid
      uuid
      first_name
      other_name
      last_name
      title
      phone
      email
      sent
      category_id
      status {
        whatsapp {
          sent_at
          delivered_at
          read_at
          failed_at
          failure_reason
        }
        sms {
          sent_at
          delivered_at
          read_at
          failed_at
          failure_reason
        }
        email {
          sent_at
          delivered_at
          read_at
          failed_at
          failure_reason
        }
      }
      category {
        id
        event_id
        name
        message
        created_at
        updated_at
      }
      rsvp_status
      created_at
      updated_at
    }
  }
`;

export const GetGuestUploads = gql`
  query GetPov($eventId: String!) {
    getPov(event_id: $eventId) {
      guest {
        id
        uuid
        email
        first_name
        image
        last_name
        other_name
        title
        gender
        phone_number
        verified
        guest
        created_at
        updated_at
        lastLoggedInAt
      }
      total_likes
      total_media_count
      total_videos
      total_pictures
      media {
        id
        name
        url
        tags
        type
        meta {
          s3_url
          height
          width
        }
        private
        user_id
        event_id
        album_id
        album {
          id
          name
        }
        likes
        user_type
        created_at
        updated_at
      }
    }
  }
`;

export const GetInawoPassProgress = gql`
  query GetInawoPassProgress($eventId: UUID!) {
    getInawoPassProgress(event_id: $eventId) {
      in_progress
      total_guest
      total_sent
    }
  }
`;

export const GetAsoEbi = gql`
  query GetAseobi($event_id: UUID!) {
    getAseobi(event_id: $event_id) {
      id
      event_id
      category_id
      name
      description
      status
      created_at
      updated_at
    }
  }
`;

export const GetAsoEbiAttires = gql`
  query GetAseobiAttires($event_id: UUID!, $aseobi_id: UUID!) {
    getAseobiAttires(event_id: $event_id, aseobi_id: $aseobi_id) {
      id
      event_id
      aseobi_id
      name
      note
      images
      description
      currency_iso
      price_per_yard
      fee_percentage
      total_price_per_yard
      yards_available
      yards_sold
      active
      created_at
      updated_at
    }
  }
`;

export const GetAsoEbiOrders = gql`
  query GetAseobiOrders($event_id: UUID!) {
    getAseobiOrders(event_id: $event_id) {
      id
      provider
      provider_reference
      event_id
      aseobi_id
      aseobi_attire_id
      user_id
      note
      contact_email
      contact_phone_number
      delivery_address
      quantity
      yards
      price_per_yard
      fee_percentage
      total_price
      created_at
      user {
        first_name
        last_name
      }
    }
  }
`;

export const GET_DOJAH_BANK_LIST = gql`
  query dojahBankList {
    dojahBankList {
      code
      name
    }
  }
`;

export const DescribeAseobiFeePercentage = gql`
  query DescribeAseobiFeePercentage($eventID: UUID!) {
    describeAseobiFeePercentage(eventID: $eventID)
  }
`;
